// extracted by mini-css-extract-plugin
export default {"page":"LayoutFullWidth__page___xdh_c","container":"LayoutFullWidth__container___xRjbV"};